/**
 * 应用配置文件
 * 根据环境自动选择 API 地址
 */

// 判断是否为生产环境
const isProduction = process.env.NODE_ENV === 'production'

// API 地址配置
// 开发环境使用本地 Flask 服务器
// 生产环境使用 Cloudflare Workers
export const API_BASE_URL = isProduction
  ? 'https://tree-management-api.jimt40395.workers.dev'
  : 'http://localhost:5001'

export default {
  API_BASE_URL
}

